let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6A4dK")).then(() => parcelRequire('jgi3y'));